module.exports = __webpack_public_path__ + "img/borderWavesBlue.b1bcf42b.svg";